import { Skeleton } from "@mallardbay/lib-react-components"
import React from "react"

export default function SmallTextSkeleton() {
    return <Skeleton width="80px" height="20px" />
}
